// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { CreateGuarantorDTO } from '../models';
import { TenantDTO } from '../models';
/**
 * TenancyUsersApi - axios parameter creator
 * @export
 */
export const TenancyUsersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Add a guarantor to a tenancy user
         * @param {string} tenancyUserId Tenancy user id
         * @param {string} tenancyId Tenancy id
         * @param {CreateGuarantorDTO} createGuarantorDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addGuarantor(tenancyUserId: string, tenancyId: string, createGuarantorDTO: CreateGuarantorDTO, options: any = {}): RequestArgs {
            // verify required parameter 'tenancyUserId' is not null or undefined
            if (tenancyUserId === null || tenancyUserId === undefined) {
                throw new RequiredError('tenancyUserId','Required parameter tenancyUserId was null or undefined when calling addGuarantor.');
            }
            // verify required parameter 'tenancyId' is not null or undefined
            if (tenancyId === null || tenancyId === undefined) {
                throw new RequiredError('tenancyId','Required parameter tenancyId was null or undefined when calling addGuarantor.');
            }
            // verify required parameter 'createGuarantorDTO' is not null or undefined
            if (createGuarantorDTO === null || createGuarantorDTO === undefined) {
                throw new RequiredError('createGuarantorDTO','Required parameter createGuarantorDTO was null or undefined when calling addGuarantor.');
            }
            const localVarPath = `/v2/tenancies/{tenancyId}/tenancyUsers/{tenancyUserId}/guarantor`
                .replace(`{${"tenancyUserId"}}`, encodeURIComponent(String(tenancyUserId)))
                .replace(`{${"tenancyId"}}`, encodeURIComponent(String(tenancyId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"CreateGuarantorDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(createGuarantorDTO !== undefined ? createGuarantorDTO : {}) : (createGuarantorDTO || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete a guarantor on a tenancy user
         * @param {string} tenancyUserId Tenancy user id
         * @param {string} tenancyId Tenancy id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGuarantor(tenancyUserId: string, tenancyId: string, options: any = {}): RequestArgs {
            // verify required parameter 'tenancyUserId' is not null or undefined
            if (tenancyUserId === null || tenancyUserId === undefined) {
                throw new RequiredError('tenancyUserId','Required parameter tenancyUserId was null or undefined when calling deleteGuarantor.');
            }
            // verify required parameter 'tenancyId' is not null or undefined
            if (tenancyId === null || tenancyId === undefined) {
                throw new RequiredError('tenancyId','Required parameter tenancyId was null or undefined when calling deleteGuarantor.');
            }
            const localVarPath = `/v2/tenancies/{tenancyId}/tenancyUsers/{tenancyUserId}/guarantor`
                .replace(`{${"tenancyUserId"}}`, encodeURIComponent(String(tenancyUserId)))
                .replace(`{${"tenancyId"}}`, encodeURIComponent(String(tenancyId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Send a reminder email to a tenant who has incomplete actions on a Reposit
         * @param {string} tenancyUserId Tenancy user id
         * @param {string} tenancyId Tenancy id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendReminderEmail(tenancyUserId: string, tenancyId: string, options: any = {}): RequestArgs {
            // verify required parameter 'tenancyUserId' is not null or undefined
            if (tenancyUserId === null || tenancyUserId === undefined) {
                throw new RequiredError('tenancyUserId','Required parameter tenancyUserId was null or undefined when calling sendReminderEmail.');
            }
            // verify required parameter 'tenancyId' is not null or undefined
            if (tenancyId === null || tenancyId === undefined) {
                throw new RequiredError('tenancyId','Required parameter tenancyId was null or undefined when calling sendReminderEmail.');
            }
            const localVarPath = `/v2/tenancies/{tenancyId}/tenancyUsers/{tenancyUserId}/sendReminderEmail`
                .replace(`{${"tenancyUserId"}}`, encodeURIComponent(String(tenancyUserId)))
                .replace(`{${"tenancyId"}}`, encodeURIComponent(String(tenancyId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Update a guarantor on a tenancy user
         * @param {string} tenancyUserId Tenancy user id
         * @param {string} tenancyId Tenancy id
         * @param {CreateGuarantorDTO} createGuarantorDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGuarantor(tenancyUserId: string, tenancyId: string, createGuarantorDTO: CreateGuarantorDTO, options: any = {}): RequestArgs {
            // verify required parameter 'tenancyUserId' is not null or undefined
            if (tenancyUserId === null || tenancyUserId === undefined) {
                throw new RequiredError('tenancyUserId','Required parameter tenancyUserId was null or undefined when calling updateGuarantor.');
            }
            // verify required parameter 'tenancyId' is not null or undefined
            if (tenancyId === null || tenancyId === undefined) {
                throw new RequiredError('tenancyId','Required parameter tenancyId was null or undefined when calling updateGuarantor.');
            }
            // verify required parameter 'createGuarantorDTO' is not null or undefined
            if (createGuarantorDTO === null || createGuarantorDTO === undefined) {
                throw new RequiredError('createGuarantorDTO','Required parameter createGuarantorDTO was null or undefined when calling updateGuarantor.');
            }
            const localVarPath = `/v2/tenancies/{tenancyId}/tenancyUsers/{tenancyUserId}/guarantor`
                .replace(`{${"tenancyUserId"}}`, encodeURIComponent(String(tenancyUserId)))
                .replace(`{${"tenancyId"}}`, encodeURIComponent(String(tenancyId)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"CreateGuarantorDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(createGuarantorDTO !== undefined ? createGuarantorDTO : {}) : (createGuarantorDTO || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TenancyUsersApi - functional programming interface
 * @export
 */
export const TenancyUsersApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Add a guarantor to a tenancy user
         * @param {string} tenancyUserId Tenancy user id
         * @param {string} tenancyId Tenancy id
         * @param {CreateGuarantorDTO} createGuarantorDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addGuarantor(tenancyUserId: string, tenancyId: string, createGuarantorDTO: CreateGuarantorDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantDTO> {
            const localVarAxiosArgs = TenancyUsersApiAxiosParamCreator(configuration).addGuarantor(tenancyUserId, tenancyId, createGuarantorDTO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Delete a guarantor on a tenancy user
         * @param {string} tenancyUserId Tenancy user id
         * @param {string} tenancyId Tenancy id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGuarantor(tenancyUserId: string, tenancyId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantDTO> {
            const localVarAxiosArgs = TenancyUsersApiAxiosParamCreator(configuration).deleteGuarantor(tenancyUserId, tenancyId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Send a reminder email to a tenant who has incomplete actions on a Reposit
         * @param {string} tenancyUserId Tenancy user id
         * @param {string} tenancyId Tenancy id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendReminderEmail(tenancyUserId: string, tenancyId: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<object> {
            const localVarAxiosArgs = TenancyUsersApiAxiosParamCreator(configuration).sendReminderEmail(tenancyUserId, tenancyId, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Update a guarantor on a tenancy user
         * @param {string} tenancyUserId Tenancy user id
         * @param {string} tenancyId Tenancy id
         * @param {CreateGuarantorDTO} createGuarantorDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGuarantor(tenancyUserId: string, tenancyId: string, createGuarantorDTO: CreateGuarantorDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<TenantDTO> {
            const localVarAxiosArgs = TenancyUsersApiAxiosParamCreator(configuration).updateGuarantor(tenancyUserId, tenancyId, createGuarantorDTO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * TenancyUsersApi - factory interface
 * @export
 */
export const TenancyUsersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Add a guarantor to a tenancy user
         * @param {string} tenancyUserId Tenancy user id
         * @param {string} tenancyId Tenancy id
         * @param {CreateGuarantorDTO} createGuarantorDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        addGuarantor(tenancyUserId: string, tenancyId: string, createGuarantorDTO: CreateGuarantorDTO, options?: any) {
            return TenancyUsersApiFp(configuration).addGuarantor(tenancyUserId, tenancyId, createGuarantorDTO, options)(axios, basePath);
        },
        /**
         * Delete a guarantor on a tenancy user
         * @param {string} tenancyUserId Tenancy user id
         * @param {string} tenancyId Tenancy id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteGuarantor(tenancyUserId: string, tenancyId: string, options?: any) {
            return TenancyUsersApiFp(configuration).deleteGuarantor(tenancyUserId, tenancyId, options)(axios, basePath);
        },
        /**
         * Send a reminder email to a tenant who has incomplete actions on a Reposit
         * @param {string} tenancyUserId Tenancy user id
         * @param {string} tenancyId Tenancy id
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        sendReminderEmail(tenancyUserId: string, tenancyId: string, options?: any) {
            return TenancyUsersApiFp(configuration).sendReminderEmail(tenancyUserId, tenancyId, options)(axios, basePath);
        },
        /**
         * Update a guarantor on a tenancy user
         * @param {string} tenancyUserId Tenancy user id
         * @param {string} tenancyId Tenancy id
         * @param {CreateGuarantorDTO} createGuarantorDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateGuarantor(tenancyUserId: string, tenancyId: string, createGuarantorDTO: CreateGuarantorDTO, options?: any) {
            return TenancyUsersApiFp(configuration).updateGuarantor(tenancyUserId, tenancyId, createGuarantorDTO, options)(axios, basePath);
        },
    };
};

/**
 * TenancyUsersApi - interface
 * @export
 * @interface TenancyUsersApi
 */
export interface TenancyUsersApiInterface {
    /**
     * Add a guarantor to a tenancy user
     * @param {string} tenancyUserId Tenancy user id
     * @param {string} tenancyId Tenancy id
     * @param {CreateGuarantorDTO} createGuarantorDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenancyUsersApiInterface
     */
    addGuarantor(tenancyUserId: string, tenancyId: string, createGuarantorDTO: CreateGuarantorDTO, options?: any): AxiosPromise<TenantDTO>;

    /**
     * Delete a guarantor on a tenancy user
     * @param {string} tenancyUserId Tenancy user id
     * @param {string} tenancyId Tenancy id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenancyUsersApiInterface
     */
    deleteGuarantor(tenancyUserId: string, tenancyId: string, options?: any): AxiosPromise<TenantDTO>;

    /**
     * Send a reminder email to a tenant who has incomplete actions on a Reposit
     * @param {string} tenancyUserId Tenancy user id
     * @param {string} tenancyId Tenancy id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenancyUsersApiInterface
     */
    sendReminderEmail(tenancyUserId: string, tenancyId: string, options?: any): AxiosPromise<object>;

    /**
     * Update a guarantor on a tenancy user
     * @param {string} tenancyUserId Tenancy user id
     * @param {string} tenancyId Tenancy id
     * @param {CreateGuarantorDTO} createGuarantorDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenancyUsersApiInterface
     */
    updateGuarantor(tenancyUserId: string, tenancyId: string, createGuarantorDTO: CreateGuarantorDTO, options?: any): AxiosPromise<TenantDTO>;

}

/**
 * TenancyUsersApi - object-oriented interface
 * @export
 * @class TenancyUsersApi
 * @extends {BaseAPI}
 */
export class TenancyUsersApi extends BaseAPI implements TenancyUsersApiInterface {
    /**
     * Add a guarantor to a tenancy user
     * @param {string} tenancyUserId Tenancy user id
     * @param {string} tenancyId Tenancy id
     * @param {CreateGuarantorDTO} createGuarantorDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenancyUsersApi
     */
    public addGuarantor(tenancyUserId: string, tenancyId: string, createGuarantorDTO: CreateGuarantorDTO, options?: any) {
        return TenancyUsersApiFp(this.configuration).addGuarantor(tenancyUserId, tenancyId, createGuarantorDTO, options)(this.axios, this.basePath);
    }

    /**
     * Delete a guarantor on a tenancy user
     * @param {string} tenancyUserId Tenancy user id
     * @param {string} tenancyId Tenancy id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenancyUsersApi
     */
    public deleteGuarantor(tenancyUserId: string, tenancyId: string, options?: any) {
        return TenancyUsersApiFp(this.configuration).deleteGuarantor(tenancyUserId, tenancyId, options)(this.axios, this.basePath);
    }

    /**
     * Send a reminder email to a tenant who has incomplete actions on a Reposit
     * @param {string} tenancyUserId Tenancy user id
     * @param {string} tenancyId Tenancy id
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenancyUsersApi
     */
    public sendReminderEmail(tenancyUserId: string, tenancyId: string, options?: any) {
        return TenancyUsersApiFp(this.configuration).sendReminderEmail(tenancyUserId, tenancyId, options)(this.axios, this.basePath);
    }

    /**
     * Update a guarantor on a tenancy user
     * @param {string} tenancyUserId Tenancy user id
     * @param {string} tenancyId Tenancy id
     * @param {CreateGuarantorDTO} createGuarantorDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TenancyUsersApi
     */
    public updateGuarantor(tenancyUserId: string, tenancyId: string, createGuarantorDTO: CreateGuarantorDTO, options?: any) {
        return TenancyUsersApiFp(this.configuration).updateGuarantor(tenancyUserId, tenancyId, createGuarantorDTO, options)(this.axios, this.basePath);
    }

}

/**
 * Standalone tree-shakeable functions for TenancyUsersApi
 * Import individual functions for optimal bundle size
 */
/**
 * Add a guarantor to a tenancy user
 * @param {string} tenancyUserId Tenancy user id
 * @param {string} tenancyId Tenancy id
 * @param {CreateGuarantorDTO} createGuarantorDTO 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function addGuarantor(
    tenancyUserId: string,
    tenancyId: string,
    createGuarantorDTO: CreateGuarantorDTO,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<TenantDTO> {
    const localVarAxiosArgs = TenancyUsersApiAxiosParamCreator(configuration).addGuarantor(tenancyUserId, tenancyId, createGuarantorDTO, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Delete a guarantor on a tenancy user
 * @param {string} tenancyUserId Tenancy user id
 * @param {string} tenancyId Tenancy id
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function deleteGuarantor(
    tenancyUserId: string,
    tenancyId: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<TenantDTO> {
    const localVarAxiosArgs = TenancyUsersApiAxiosParamCreator(configuration).deleteGuarantor(tenancyUserId, tenancyId, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Send a reminder email to a tenant who has incomplete actions on a Reposit
 * @param {string} tenancyUserId Tenancy user id
 * @param {string} tenancyId Tenancy id
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function sendReminderEmail(
    tenancyUserId: string,
    tenancyId: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<object> {
    const localVarAxiosArgs = TenancyUsersApiAxiosParamCreator(configuration).sendReminderEmail(tenancyUserId, tenancyId, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Update a guarantor on a tenancy user
 * @param {string} tenancyUserId Tenancy user id
 * @param {string} tenancyId Tenancy id
 * @param {CreateGuarantorDTO} createGuarantorDTO 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function updateGuarantor(
    tenancyUserId: string,
    tenancyId: string,
    createGuarantorDTO: CreateGuarantorDTO,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<TenantDTO> {
    const localVarAxiosArgs = TenancyUsersApiAxiosParamCreator(configuration).updateGuarantor(tenancyUserId, tenancyId, createGuarantorDTO, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

